  (function () {
    if (window.__hwCardProductSlider) return;
    window.__hwCardProductSlider = true;

    var sliderState = new WeakMap();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileSliderQuery = window.matchMedia('(max-width: 749px)');

    function isMobileSlider() {
      return mobileSliderQuery.matches;
    }

    function isRelatedProductsCard(card) {
      return !!(card && card.closest && card.closest('product-recommendations.related-products, .related-products'));
    }

    function getVisibleSlides(track) {
      return Array.prototype.filter.call(track.children, function (slide) {
        return slide.classList && slide.classList.contains('card-image-slide') && slide.style.display !== 'none';
      });
    }

    function cacheVisible(state) {
      state.visible = getVisibleSlides(state.track);
      state.slideCount = state.visible.length;
      return state.visible;
    }

    function preloadSlide(slide) {
      var img = slide && slide.querySelector('img');
      if (!img || img.dataset.hwPreloaded === 'true') return;
      img.dataset.hwPreloaded = 'true';
      if (typeof img.decode === 'function') img.decode().catch(function () {});
    }

    function preloadNearby(state) {
      var visible = state.visible || cacheVisible(state);
      if (!visible.length) return;
      preloadSlide(visible[state.current]);
      preloadSlide(visible[(state.current + 1) % visible.length]);
      if (visible.length > 2) preloadSlide(visible[(state.current - 1 + visible.length) % visible.length]);
    }

    function setSlideWidths(state) {
      var scroller = state.scroller;
      if (!scroller) return;
      var width = Math.round(scroller.getBoundingClientRect().width) || scroller.clientWidth || 0;
      if (!width) return;
      state.trackWidth = width;
      scroller.style.setProperty('--hw-card-slide-width', width + 'px');
      var slides = state.track.querySelectorAll('.card-image-slide');
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = width + 'px';
        slides[i].style.minWidth = width + 'px';
        slides[i].style.maxWidth = width + 'px';
        slides[i].style.flex = '0 0 ' + width + 'px';
      }
    }

    function applyDesktopMode(state) {
      state.slider.classList.remove('is-native-scroll');
      state.track.style.width = '';
      state.track.style.maxWidth = '';
      state.track.style.transform = 'translate3d(-' + state.current * 100 + '%, 0, 0)';
      var slides = state.track.querySelectorAll('.card-image-slide');
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = '';
        slides[i].style.minWidth = '';
        slides[i].style.maxWidth = '';
        slides[i].style.flex = '';
      }
      if (state.scroller) {
        state.scroller.style.removeProperty('--hw-card-slide-width');
        state.scroller.scrollLeft = 0;
      }
    }

    function applyMobileMode(state, forceScroll) {
      /* Related products: outer carousel owns swipe — keep first image only */
      if (state.relatedProducts) {
        state.slider.classList.remove('is-native-scroll');
        state.track.style.transform = 'none';
        state.track.style.transition = 'none';
        state.track.style.width = '100%';
        state.track.style.maxWidth = '100%';
        state.track.classList.remove('is-dragging');
        if (state.scroller) {
          /* clip / visible: must NOT be a nested overflow scrollport */
          state.scroller.style.overflow = 'clip';
          state.scroller.style.overflowX = 'clip';
          state.scroller.style.overflowY = 'clip';
          state.scroller.style.touchAction = 'manipulation';
          state.scroller.scrollLeft = 0;
          state.scroller.style.removeProperty('--hw-card-slide-width');
        }
        if (state.slider) {
          state.slider.style.overflow = 'clip';
        }
        var slides = state.track.querySelectorAll('.card-image-slide');
        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '100%';
          slides[i].style.minWidth = '100%';
          slides[i].style.maxWidth = '100%';
          slides[i].style.flex = '0 0 100%';
          slides[i].style.display = i === 0 ? '' : 'none';
        }
        return;
      }
      state.slider.classList.add('is-native-scroll');
      state.track.style.transform = 'none';
      state.track.style.transition = 'none';
      state.track.style.width = 'max-content';
      state.track.style.maxWidth = 'none';
      state.track.classList.remove('is-dragging');
      setSlideWidths(state);
      if (!state.scroller) return;
      if (forceScroll) {
        state.scroller.scrollLeft = state.current * (state.trackWidth || state.scroller.clientWidth || 0);
      }
    }

    function updateSlider(state, animate, forceScroll) {
      var visible = cacheVisible(state);
      if (!visible.length) return;
      if (state.current >= visible.length) state.current = 0;
      if (state.current < 0) state.current = visible.length - 1;

      if (isMobileSlider()) {
        applyMobileMode(state, forceScroll === true);
      } else {
        if (!animate || reducedMotion.matches) {
          state.track.classList.add('is-dragging');
          state.track.style.transition = 'none';
        } else {
          state.track.classList.remove('is-dragging');
          state.track.style.transition = '';
        }
        applyDesktopMode(state);
        if (!animate || reducedMotion.matches) {
          requestAnimationFrame(function () {
            state.track.classList.remove('is-dragging');
            state.track.style.transition = '';
          });
        }
      }
      preloadNearby(state);
    }

    function goTo(card, direction) {
      var state = sliderState.get(card);
      if (!state) return;
      var visible = cacheVisible(state);
      if (visible.length <= 1) return;
      if (direction === 'next') state.current = (state.current + 1) % visible.length;
      else state.current = (state.current - 1 + visible.length) % visible.length;
      updateSlider(state, true, true);
    }

    function setupNativeMobileScroll(card, state) {
      var scroller = state.scroller;
      if (!scroller || scroller.dataset.mobileSwipeReady === 'true') return;
      scroller.dataset.mobileSwipeReady = 'true';

      var scrollStart = 0;
      var moved = false;

      scroller.addEventListener('scroll', function () {
        if (!isMobileSlider()) return;
        var width = state.trackWidth || scroller.clientWidth || 1;
        var index = Math.round(scroller.scrollLeft / width);
        var visible = state.visible || cacheVisible(state);
        if (!visible.length) return;
        if (index < 0) index = 0;
        if (index >= visible.length) index = visible.length - 1;
        if (index !== state.current) {
          state.current = index;
          preloadNearby(state);
        }
      }, { passive: true });

      scroller.addEventListener('touchstart', function () {
        if (!isMobileSlider()) return;
        scrollStart = scroller.scrollLeft;
        moved = false;
        setSlideWidths(state);
        preloadNearby(state);
      }, { passive: true });

      scroller.addEventListener('touchmove', function () {
        if (!isMobileSlider()) return;
        if (Math.abs(scroller.scrollLeft - scrollStart) > 8) moved = true;
      }, { passive: true });

      scroller.addEventListener('touchend', function () {
        if (!isMobileSlider()) return;
        if (Math.abs(scroller.scrollLeft - scrollStart) > 8) {
          moved = true;
          state.blockClickUntil = Date.now() + 275;
        }
      }, { passive: true });

      scroller.addEventListener('click', function (e) {
        if (!isMobileSlider()) return;
        if (moved || (state.blockClickUntil && Date.now() < state.blockClickUntil)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
        moved = false;
      }, true);
    }

    function initCardSliders(root) {
      var cards = [];
      if (!root || root === document) cards = Array.prototype.slice.call(document.querySelectorAll('.card-wrapper'));
      else if (root.matches && root.matches('.card-wrapper')) cards = [root];
      else if (root.querySelectorAll) cards = Array.prototype.slice.call(root.querySelectorAll('.card-wrapper'));

      cards.forEach(function (card) {
        if (card.dataset.sliderInit === 'true') return;
        var slider = card.querySelector('[data-card-image-slider]');
        var track = card.querySelector('.card-image-slider__track');
        var scroller = card.querySelector('.card-image-slider-link');
        if (!slider || !track) return;
        var relatedProducts = isRelatedProductsCard(card);
        var slideCount = parseInt(slider.getAttribute('data-slide-count') || '0', 10);

        /* Related products: always freeze inner media swipe (even 1 slide) */
        if (relatedProducts) {
          card.dataset.sliderInit = 'true';
          var relatedState = {
            track: track,
            slider: slider,
            scroller: scroller,
            current: 0,
            visible: null,
            slideCount: Math.max(slideCount, 1),
            trackWidth: 0,
            blockClickUntil: 0,
            relatedProducts: true
          };
          sliderState.set(card, relatedState);
          cacheVisible(relatedState);
          updateSlider(relatedState, false, true);
          return;
        }

        if (slideCount <= 1) {
          track.style.transform = '';
          return;
        }

        card.dataset.sliderInit = 'true';
        var state = {
          track: track,
          slider: slider,
          scroller: scroller,
          current: 0,
          visible: null,
          slideCount: slideCount,
          trackWidth: 0,
          blockClickUntil: 0,
          relatedProducts: false
        };
        sliderState.set(card, state);
        card.addEventListener('card-slider:reset', function () {
          state.current = 0;
          cacheVisible(state);
          updateSlider(state, false, true);
        });
        setupNativeMobileScroll(card, state);
        cacheVisible(state);
        updateSlider(state, false, true);
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.card-slider-arrow--next, .card-slider-arrow--prev');
      if (!button) return;
      var card = button.closest('.card-wrapper');
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (!sliderState.has(card)) initCardSliders(card);
      goTo(card, button.classList.contains('card-slider-arrow--next') ? 'next' : 'prev');
    }, true);

    window.hwInitCardSliders = initCardSliders;

    function boot() { initCardSliders(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function (e) { initCardSliders(e.target); });
    document.addEventListener('hw:facets-updated', function (e) {
      initCardSliders(e.detail && e.detail.container ? e.detail.container : document);
    });

    mobileSliderQuery.addEventListener('change', function () {
      document.querySelectorAll('.card-wrapper[data-slider-init="true"]').forEach(function (card) {
        var state = sliderState.get(card);
        if (state) updateSlider(state, false, true);
      });
    });

    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!isMobileSlider()) return;
        document.querySelectorAll('.card-wrapper[data-slider-init="true"]').forEach(function (card) {
          var state = sliderState.get(card);
          if (!state || state.relatedProducts || !state.scroller) return;
          setSlideWidths(state);
          state.scroller.scrollLeft = state.current * (state.trackWidth || 0);
        });
      }, 120);
    }, { passive: true });

    var gridObserverQueued = false;
    new MutationObserver(function (mutations) {
      if (gridObserverQueued) return;
      var shouldInit = false;
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches('.card-wrapper, #ProductGridContainer, .product-grid, product-recommendations')) ||
              (node.querySelector && node.querySelector('.card-wrapper'))) {
            shouldInit = true;
            break;
          }
        }
        if (shouldInit) break;
      }
      if (!shouldInit) return;
      gridObserverQueued = true;
      requestAnimationFrame(function () {
        gridObserverQueued = false;
        initCardSliders(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  